
jQuery(document).ready(function($) {
   

   $('#laboratories').slick({
     dots: false,
     infinite:false,
     slidesToShow: 3,
     unslick : true, 
     draggable: false,
     arrows: false,
     responsive: [
         {
           breakpoint: 1024,
           settings: {
              dots: true,
              slidesToShow: 3,
              draggable: true,
           }
         }, 
         {
            breakpoint: 800,
            settings: {
               dots: true,
               slidesToShow: 2.5,
               draggable: true,
            }
         },
         {
            breakpoint: 650,
            settings: {
               dots: true,
               slidesToShow: 1.8,
               draggable: true,
            }
         }, 
         {
           breakpoint: 500,
           settings: {
              dots: true,
              slidesToShow: 1.2,
              draggable: true,
           }
         }, 
      ]
   });

   $('.l-testing__locations__item__link').on('click',function() {

      var id = $(this).data('id');
      var dom =  $('#'+id);
      dom.addClass('open');

   
      var picture = dom.find('.m-value-bloc__picture__bg');
      var bg = picture.data('bg');
      var mask = dom.find('.m-value-bloc__picture__bg__mask');
      var img  = dom.find('.m-value-bloc__picture__bg__img');
      
      mask.addClass("m-value-bloc__picture__bg__mask--translate").delay(500).queue(function(){
         var parent = $(this).parent();
         img.css('background-image', 'url(' + bg + ')');
         parent.addClass('show');
         $(this).addClass("m-value-bloc__picture__bg__mask--visible").dequeue();
     
      });
   });


   $('.l-testing__laboratories__item__button').on('click',function() {

      var id = $(this).data('id');
      var dom =  $('#'+id);
      dom.addClass('open');

      $('body').addClass('overflow');
      var picture = dom.find('.m-value-bloc__picture__bg');
      var bg = picture.data('bg');
      var mask = dom.find('.m-value-bloc__picture__bg__mask');
      var img  = dom.find('.m-value-bloc__picture__bg__img');
      
      mask.addClass("m-value-bloc__picture__bg__mask--translate").delay(500).queue(function(){
         var parent = $(this).parent();
         img.css('background-image', 'url(' + bg + ')');
         parent.addClass('show');
         $(this).addClass("m-value-bloc__picture__bg__mask--visible").dequeue();
     
      });
   });
   
   $('.m-value-bloc__close').on('click',function() {
      $('.m-value-bloc').removeClass('open');
      $('body').removeClass('overflow');
   })
});

